import React, { Component } from "react";
import { Link } from 'react-router-dom'
import NewSchemeQuestionnaire from "./QuestionnaireManager/NewSchemeQuestionnaire";
import DisplayQuestionnaireDetails from "./QuestionnaireManager/DisplayQuestionnaireDetails";
import { deleteEvaluationB } from "../../../stores/actions/evaluationBAction";
import { compose } from "redux";
import { connect } from "react-redux";

class DisplayQuestionnaireInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedAnswers: [],
            searchQuestion: '',
            selectedQuestionId: '',
            isLoading: null,

            selectedCriteria: '',
            selectedScheme: '',
            questionQuery: '',
        }
        this.childResetFunction = null;

    }


    componentDidUpdate(prevProps, prevState) {
        const { deleteEvaluationBSuccess, deleteEvaluationBError, criteria } = this.props;



        if (prevProps.deleteEvaluationBError !== deleteEvaluationBError) {
            this.setState({
                isLoading: false,
                message: {
                    msg: deleteEvaluationBError.message,
                    type: deleteEvaluationBError.type
                }
            })
        }

        if (prevProps.deleteEvaluationBSuccess !== deleteEvaluationBSuccess) {
            window.alert('Question Deleted Successfully!');
            this.setState({
                isLoading: false,
                message: {
                    msg: deleteEvaluationBSuccess.message,
                    type: deleteEvaluationBSuccess.type
                }
            });


        }


    }

    showModal_questionDetails = (selectedId) => {
        this.setState({ selectedQuestionId: selectedId });
        document.getElementById('modal-question-details').style.display = "block";

    }

    hideModal_questionDetails = () => {
        if (this.childResetFunction) {//untuk call resetState function dalam displayQuestionnaireDetails
            this.childResetFunction();
        }
        this.setState({ selectedQuestionId: '' });
        document.getElementById('modal-question-details').style.display = "none";

    }

    showModal_newQuestion = () => {
        document.getElementById('modal-new-question').style.display = "block";
    }

    hideModal_newQuestion = () => {
        //call the stored reset function
        if (this.childResetFunction) {//untuk call resetState function dalam newSchemeQuestionnaire
            this.childResetFunction();
        }

        document.getElementById('modal-new-question').style.display = "none";
    }

    deleteQuestion = (evaluationBId) => {
        const questionToDelete = this.props.evaluationB.find(
            item => item.id === evaluationBId
        );

        if (!questionToDelete) {
            console.warn('Question not found:', evaluationBId);
            return;
        }

        const confirmDelete = window.confirm(
            `Confirm Delete "${questionToDelete.question}"?`
        );

        if (confirmDelete) {
            this.props.deleteEvaluationB(evaluationBId);
        }
    }

    // clearFilter = () => {
    //     document.getElementById('clearFilterQuestion').click();
    //     this.setState({
    //         searchQuestion: ''
    //     })
    // }

    getUniqueCriteria = () => {
        const { evaluationB } = this.props;
        if (!evaluationB) return [];

        const criteria = evaluationB.map(questions => ({
            id: questions.selectedCriteria.id,
            name: questions.selectedCriteria.name
        }));

        const uniqueCriteria = Array.from(
            new Map(criteria.map(m => [m.name, m])).values()
        );

        return uniqueCriteria.sort((a, b) => a.name.localeCompare(b.name))
    }

    getFilteredQuestionnaires = () => {
        const { evaluationB } = this.props;
        const { selectedCriteria, selectedScheme, questionQuery } = this.state

        if (!evaluationB) return [];

        let filtered = evaluationB;

        //filter questionnaire based on criteria
        if (selectedCriteria) {
            filtered = filtered.filter(questionnaire =>
                questionnaire.selectedCriteria.name === selectedCriteria
            )
        }

        //filter questionnaire based on scheme
        if (selectedScheme) {
            filtered = filtered.filter(questionnaire =>
                questionnaire.selectedSchemes.some(scheme =>
                    scheme.name === selectedScheme
                )
            )
        }

        //filter questionnaire based on user search input
        if (questionQuery && questionQuery.trim()) {
            const searchTerm = questionQuery.toLowerCase().trim();
            filtered = filtered.filter(questionnaire =>
                questionnaire.question.toLowerCase().includes(searchTerm)
            )
        }

        return filtered;
    }

    // handleQuestionSearch = () => {
    //     const { questionQuery } = this.state;
    //     const { evaluationB } = this.props;

    //     // Return all data if search is empty
    //     if (!questionQuery || !questionQuery.trim()) {
    //         return evaluationB;
    //     }

    //     // Case-insensitive search using includes()
    //     const searchTerm = questionQuery.toLowerCase().trim();

    //     const searchData = evaluationB.filter(data =>
    //         data.question.toLowerCase().includes(searchTerm)
    //     );

    //     return searchData;
    // }

    clearFilters = () => {
        this.setState({
            selectedCriteria: '',
            selectedScheme: ''
        })
    }

    render() {
        const { query, schemes, criteria, profile, evaluationB, } = this.props;
        const { selectedQuestionId, selectedCriteria, selectedScheme } = this.state;
        let query_schemeId = query.get('schemeId');
        let query_schemeName = query.get('schemeName');
        let no = 0;

        const questionData = evaluationB || [];
        // let hasQuestionData = [], isLoading = true;

        // const uniqueCriteria = this.getUniqueCriteria();
        const filteredQuestionnaires = this.getFilteredQuestionnaires();
        // const searchData = this.handleQuestionSearch();
        let schemeList = schemes && schemes.map(scheme => {//get a list of schemeName list
            return (
                <span key={scheme.id}
                    className={query_schemeId ? query_schemeId === scheme.id ? 'bg-white dropdown-item' : 'dropdown-item' : 'dropdown-item'}>
                    <Link to={`systemmanager?topic=halcompass&subtopic=questionnaire&schemeId=${scheme.id}&schemeName=${scheme.name}`}>
                        {scheme.name}
                    </Link>
                </span>
            )
        })

        // console.log(searchData);
        return (
            <div>
                <div id="modal-question-details" className="mymodal">
                    <div className="mymodal-content col-md-8">
                        <span className="close" onClick={this.hideModal_questionDetails}>&times;</span>
                        <DisplayQuestionnaireDetails onMountRegister={(resetFn) => this.childResetFunction = resetFn} hideModal_questionDetails={this.hideModal_questionDetails} questionData={questionData} selectedQuestionId={selectedQuestionId} schemes={schemes} criteria={criteria} profile={profile} />
                    </div>
                </div>

                <div id="modal-new-question" className="mymodal">
                    <div className="mymodal-content col-md-8">
                        <span className="close" onClick={this.hideModal_newQuestion.bind(this)}>&times;</span>
                        <NewSchemeQuestionnaire onMountRegister={(resetFn) => this.childResetFunction = resetFn} hideModal_newQuestion={this.hideModal_newQuestion} schemes={schemes} criteria={criteria} profile={profile} />
                    </div>
                </div>
                <div className="row col-md-12">
                    <button className="btn btn-outline-black" onClick={this.showModal_newQuestion.bind(this)}>
                        <i className="fas fa-plus-circle" />{' '}Questionnaire
                    </button>


                    {/* <div className="btn-group dropdown">
                        <button type="button" className="btn border-black dropdown-toggle" data-toggle="dropdown">
                            {query_schemeName ? query_schemeName : 'Choose Scheme'}
                        </button>

                        <div className="dropdown-menu">
                            <b style={{ marginLeft: '20px' }}>Scheme</b>
                            {schemeList}
                        </div>
                    </div>
                    {query_schemeId ?
                        <div className="middle">
                            <span className="badge bg-blue text-white" onClick={this.clearFilter.bind(this)}> <i className="fas fa-times"></i>{'  '}Clear</span>
                        </div> : null} */}
                </div>

                <div className="row col-md-12">
                    <div className="col-md-4">
                        <label htmlFor=""><b>Select Criteria</b></label>
                        <select className="form-control" value={selectedCriteria} onChange={event => this.setState({ selectedCriteria: event.target.value })}>
                            <option value="">-- Choose Criteria --</option>
                            {
                                criteria?.length > 0 ? criteria.map((c, cidx) => (
                                    <option key={cidx} value={c.name}>
                                        {c.name}
                                    </option>
                                )) : (<option> Data Loading</option>)
                            }
                        </select>
                    </div>

                    <div className="col-md-4">
                        <label htmlFor=""><b>Select Scheme</b></label>
                        <select className="form-control" value={selectedScheme} onChange={event => this.setState({ selectedScheme: event.target.value })}>
                            <option value="">-- Choose Scheme --</option>
                            {
                                schemes?.length > 0 ? schemes.map((s, sidx) => (
                                    <option key={sidx} value={s.name}>
                                        {s.name} ({s.code})
                                    </option>
                                )) : (<option> Data Loading</option>)
                            }
                        </select>
                    </div>

                    <div className="col-md-2">
                        <label>&nbsp;</label>
                        <button className="btn btn-secondary form-control" onClick={this.clearFilters}>
                            Clear Filters
                        </button>
                    </div>


                </div>

                <div className="row col-md-12 flex-column">
                    <div className="col-md-6">
                        <label htmlFor=""><b>Search Question</b></label>
                        <input className="form-control" type="text" onChange={event => this.setState({ questionQuery: event.target.value })} placeholder="Search for question here..." />
                    </div>
                    {(selectedCriteria || selectedScheme) && (
                        <div className="col-md-6">
                            <small className="text-muted">
                                Showing {filteredQuestionnaires.length} of {evaluationB?.length || 0} reports
                                {selectedCriteria && `(filtered by criteria: ${selectedCriteria})`}
                                {selectedScheme && `(filtered by scheme: ${selectedScheme})`}
                            </small>
                        </div>
                    )}
                </div>

                <div className="text-left">
                    <div className="uppercase my-3">
                        <b>Inserted Question</b>
                        <div className="title-border"></div>
                    </div>

                    <table className="table">
                        <thead>
                            <tr>
                                <th className="col-md-1">No</th>
                                <th className="col-md-3">Kriteria</th>
                                <th className="col-md-4">Soalan</th>
                                <th className="col-md-2">Scheme</th>
                                <th className="col-md-2">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredQuestionnaires.length > 0 ? filteredQuestionnaires.map((evaB, index) => {
                                no = no + 1;
                                return (
                                    <tr key={evaB.id} className="border-bottom">
                                        <td>{no}</td>
                                        <td className="text-left" style={{ verticalAlign: 'center' }}>{evaB.selectedCriteria.name || ''}</td>
                                        <td className="text-left">{evaB.question}</td>
                                        <td className="align-middle">
                                            <div className="d-flex flex-wrap ">
                                                {(evaB.selectedSchemes || []).map(selectScheme => {
                                                    return (
                                                        <div className="col-md-4" key={selectScheme.id}>{selectScheme.code}</div>
                                                    )
                                                })}
                                            </div>
                                        </td>
                                        <td className="align-middle">
                                            <i className="fas fa-edit mr-3" onClick={() => this.showModal_questionDetails(evaB.id)} style={{ cursor: 'pointer' }}></i>
                                            <i className="fas fa-trash text-red" onClick={() => this.deleteQuestion(evaB.id)} style={{ cursor: 'pointer' }}></i>
                                        </td>
                                    </tr>
                                )
                            }) : (<tr><td colSpan="100%">No Data</td></tr>)}
                        </tbody>
                    </table>
                </div>

                <div hidden={true}>
                    <Link id="clearFilterQuestion" to={'/systemmanager?topic=halcompass&subtopic=questionnaire'}></Link>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        deleteEvaluationBSuccess: state.evaluationB.deleteEvaluationBSuccess,
        deleteEvaluationBError: state.evaluationB.deleteEvaluationBError
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        deleteEvaluationB: (evaluationBId) => dispatch(deleteEvaluationB(evaluationBId))
    }
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(DisplayQuestionnaireInfo)